// extracted by mini-css-extract-plugin
export default {"flipButton":"ButtonFlip-module__flipButton___CXdVK","flipIcon":"ButtonFlip-module__flipIcon___DtpZH","flipButtonIcon":"ButtonFlip-module__flipButtonIcon___PohM6"};